module.exports = require('./helpers/bundle-url').getBundleURL('73zau') + "logo-dark.ba5147f0.svg";